var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.ui.colorNavigationBar,attrs:{"row":""}},[_c('v-layout',{staticClass:"ml-3 mr-3"},[_c('StatusBarSelection'),_c('v-spacer'),_c('LinkBar'),_c('StatusBarInfo')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }